const getGoodsCategoryId = (query) => {
  const safeQuery = query || {};
  return safeQuery.categoryId || safeQuery.id || safeQuery.sort || "";
};

module.exports = { getGoodsCategoryId };



// WEBPACK FOOTER //
// ./src/util/goodsCategoryQuery.js